import { render, staticRenderFns } from "./FormBasicInfo.vue?vue&type=template&id=4e7157ed&"
import script from "./FormBasicInfo.vue?vue&type=script&lang=ts&"
export * from "./FormBasicInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e7157ed')) {
      api.createRecord('4e7157ed', component.options)
    } else {
      api.reload('4e7157ed', component.options)
    }
    module.hot.accept("./FormBasicInfo.vue?vue&type=template&id=4e7157ed&", function () {
      api.rerender('4e7157ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GoodsReceiptChecklist/FormBasicInfo.vue"
export default component.exports